import React from 'react'

export interface ArrowIconProps {
    className?: string
}

export function LongRightArrowIcon({
    className = 'js_LongRightArrowIcon',
}: ArrowIconProps) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="8"
            fill="none"
            viewBox="0 0 34 8"
        >
            <path
                fill="#000"
                d="M33.354 4.354a.5.5 0 000-.708L30.172.464a.5.5 0 10-.707.708L32.293 4l-2.828 2.828a.5.5 0 10.707.708l3.182-3.182zM0 4.5h33v-1H0v1z"
            ></path>
        </svg>
    )
}
